// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2Snnq","icon":"styles_icon__270-P","other":"styles_other__2cd3z","pullRight":"styles_pullRight__QErEb"};